import React, {Component} from 'react';
import UnitBusinessRate from './unitBusinessRate';
import * as DataService from '../../service/data-info-chart/requestsUtil';
import {BUSINESS_UNIT} from '../../utils/constants';


class satisfactionIndex extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      places: [],
      value: 3,
      period: '',
      key: 1
    };
  }

  componentDidMount() {
    DataService.getFetch(BUSINESS_UNIT)
      .then((data) => {
        this.setState({
          places: data,
          loaded: true
        });
      });
  }

  render() {

    let period = '';
    if(this.props.dateModalNumber>=1 && this.props.dateModalNumber<=6){
      period = '(Enero y Junio)'
    } else if(this.props.dateModalNumber>=6 && this.props.dateModalNumber<=12){
      period = '(Julio y Diciembre)'
    }

    let results = '';
    if (this.state.places !== []) {
      results = this.state.places.map((bu, index) => {
        let nameClass = '';
        if ((index % 2) === 0) {
          nameClass = 'back-color-grey';
        }
        else {
          nameClass = '';
        }

        //Este if elimina Culiacán y Vallarta
        if(bu.id !== 1 && bu.id !==2){
          return <UnitBusinessRate authorization={this.props.authorization} bu={bu}
                                   nameClass={nameClass} date={this.props.date}
                                   dateModal={this.props.dateModal}/>;
        }
      });
    }

    return (
      <div>
        <div className='container-fluid back-color-grey'>
          <div className='row'>
            <div className='container-fluid quality-title-1'>
              Índice de satisfacción del cliente semestral {period}
            </div>
          </div>
          <div className='d-flex justify-content-center'>
            <h3>Objetivo mínimo cuatro puntos</h3>
          </div>
        </div>
        <div className='container-fluid p-0'>
          {results}
        </div>
      </div>
    );
  }
}

export default satisfactionIndex;



// WEBPACK FOOTER //
// ./src/components/satisfactionIndex/satisfactionIndex.js